"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectToHelpCenter = redirectToHelpCenter;
const common_1 = require("../types/common");
const types_1 = require("../sdk/types");
const store_locale_1 = require("../utils/store-locale");
const url_config_1 = require("./url-config");
const LOCALE_PLACEHOLDER = '{locale}';
function getLocale() {
    const { locale } = (0, store_locale_1.getStoreLocale)();
    // opening "en" locale in Zendesk redirects to the last used locale (eg. "de"), so we should explicitly redirect to "en-us"
    return locale === common_1.Locale.EN ? 'en-us' : locale;
}
function isHelpCenterPage(page) {
    return (
    // if "openHelpCenter" is used as "onClick={openHelpCenter}" it gets an Event as a first argument, we filter it out
    typeof page === 'string' &&
        Object.values(types_1.HelpCenterPage).includes(page));
}
function redirectToHelpCenter(page = types_1.HelpCenterPage.Faq) {
    const locale = getLocale();
    const config = (0, url_config_1.getUrlConfig)();
    const baseUrlWithLocale = config.baseUrl.replace(LOCALE_PLACEHOLDER, locale);
    const pageUrl = isHelpCenterPage(page)
        ? config.pages[page]
        : config.pages[types_1.HelpCenterPage.Faq];
    window.open(`${baseUrlWithLocale}${pageUrl}`, '_blank');
}
//# sourceMappingURL=index.js.map